import UserSessionService from "./UserSessionService"


const api_url = process.env.REACT_APP_API_URL;

export function get(resource, params, expected_code) {
  let queryString = require('querystring');
  let paramString = queryString.stringify(params);
  let url = resource + (paramString.length > 0 ? "?" : "") + paramString;
  return executeRequest(url, "GET", undefined, undefined, expected_code);
}
export function post(resource, body, expected_code) {
  return executeRequest(resource,"POST", body, undefined, expected_code);
}
export function put(resource, body, expected_code) {
  return executeRequest(resource,"PUT", body, undefined, expected_code);
}
export function patch(resource, body, expected_code) {
  return executeRequest(resource,"PATCH", body, undefined, expected_code);
}
export function del(resource, body, expected_code) {
  return executeRequest(resource,"DELETE", body, undefined, expected_code);
}

export function getWithHeaders(resource, params, expected_code, headers) {
  let queryString = require('querystring');
  let paramString = queryString.stringify(params);
  let url = resource + (paramString.length > 0 ? "?" : "") + paramString;
  return executeRequest(url, "GET", undefined, headers, expected_code);
}
export function postWithHeaders(resource, body, expected_code, headers) {
  return executeRequest(resource,"POST", body, headers, expected_code);
}
export function putWithHeaders(resource, body, expected_code, headers) {
  return executeRequest(resource,"PUT", body, headers, expected_code);
}
export function patchWithHeaders(resource, body, expected_code, headers) {
  return executeRequest(resource,"PATCH", body, headers, expected_code);
}
export function delWithHeaders(resource, body, expected_code, headers) {
  return executeRequest(resource,"DELETE", body, headers, expected_code);
}

function executeRequest(resource, method, body, headers, expected_code){

  return new Promise(function (resolve, reject) {
    let requestParams = getRequestParams(method, body, headers);
    let url = api_url + resource;

    return fetch(url, requestParams)
      .then(resp => handleResponse(resp, resolve, reject, expected_code))
      .catch(resp=> handleRejection(resp, reject));
  });
}
const getRequestParams = function (method, body, requestHeaders) {

  let headers = {};
  if(requestHeaders===undefined || requestHeaders["Authorization"]===undefined) {
    if(!UserSessionService.isSessionValid()) {
      return;
    }
    let base64EncodedCredentials = UserSessionService.getBasicAuth();
      headers['Authorization'] = base64EncodedCredentials;
  }

  if (requestHeaders !== undefined) {
    Object.keys(requestHeaders).forEach(key => {
      headers[key] = requestHeaders[key];
    })

  }

  if (body !== undefined)
    headers['Content-Type'] = 'application/json';
  return {
    method: method,
    body: body !== undefined ? JSON.stringify(body) : undefined,
    headers: new Headers(headers)
  };
};
const extractResponse = function(res){
  const contentType = res.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
    return res.json();
  }
  else {
    return res.text();
  }
};
const handleResponse = function(resp, resolve, reject, expected_code=200){
  let json = extractResponse(resp);
  if(resp.status===expected_code){
    return json.then(body=>{ return resolve({"headers":resp.headers,"body": body})})
  }else{
    return json.then(Promise.reject.bind(Promise));
  }
};

const handleRejection = function (response, reject) {
  if (response.message && response["error-code"])
    return reject(response);
  else {
    let errorObj = {};
    errorObj.message = response.message;
    errorObj["error-code"] = response.status;
    return reject(errorObj);
  }
};

const RawWsService = {
  get, post, put, patch, del,
  getWithHeaders, postWithHeaders, putWithHeaders, patchWithHeaders, delWithHeaders,
  getRequestParams, handleRejection
};
export default RawWsService;
